/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub CoPilot, OpenAI ChatGPT or others.
 */

export const featureEnvironmentKeys = Object.freeze({
  preview: 'preview',
  supportChat: 'support-chat',
});

/** Hostname second label (e.g. develop / us) for {service}.{region}.commandalkon.io */
const featureEnvironmentRegions = {
  [featureEnvironmentKeys.preview]: ['localhost', 'develop', 'pre-develop'],
  [featureEnvironmentKeys.supportChat]: ['localhost', 'develop', 'pre-develop', 'uat', 'us'],
};

const isLocalhostStyleHostname = hostname => hostname === 'localhost' || hostname.startsWith('localhost.');

export const isFeatureEnvironment = (environmentKey = featureEnvironmentKeys.preview) => {
  if (typeof window === 'undefined' || !window.location?.hostname) {
    return false;
  }

  const regions =
    featureEnvironmentRegions[environmentKey] ?? featureEnvironmentRegions[featureEnvironmentKeys.preview];

  const hostname = window.location.hostname;

  if (isLocalhostStyleHostname(hostname)) {
    return regions.includes('localhost');
  }

  const parts = hostname.split('.');

  if (parts.length >= 2 && regions.includes(parts[1])) {
    return true;
  }

  return false;
};
